import Vue from 'vue'
import Router from "vue-router"

// component

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: to => {
      const authHeaders = $cookies.get('userAuth')
      const authData = $cookies.get('userData')

      if (authHeaders) return { name: 'pos' }

      return { name: 'auth-login' }
    },
  },
  {
    path: '/pos',
    name: 'pos',
    redirect: to => { return { name: 'pos-item' } },
    component: () => import('@/components/pos/body'),
    children: [
      {
        path: '/pos/items',
        name: 'pos-item',
        component: () => import('@/views/pos/Item.vue'),
        meta: { title: 'Carada POS - Items' },
      },
      {
        path: '/pos/transactions',
        name: 'pos-transaction',
        component: () => import('@/views/pos/Transaction.vue'),
        meta: { title: 'Carada POS - Transactions' },
      },
      {
        path: '/pos/quotations',
        name: 'pos-quotation',
        component: () => import('@/views/pos/quotation/QuotationList.vue'),
        meta: { title: 'Carada POS - Quotations' },
      },
      {
        path: '/pos/quotations/:id',
        name: 'pos-quotation-view',
        component: () => import('@/views/pos/quotation/QuotationView.vue'),
        meta: { title: 'Carada POS - Quotations' },
      },
      {
        path: '/pos/quotations/template/:id',
        name: 'pos-quotation-template-view',
        component: () => import('@/views/pos/quotation/QuotationView.vue'),
        meta: { title: 'Carada POS - Quotations' },
      },
      {
        path: '/pos/quotations/template_form/:id',
        name: 'pos-quotation-template-form',
        component: () => import('@/views/pos/quotation/QuotationForm.vue'),
        meta: { title: 'Carada POS - Quotations' },
      },
      {
        path: '/pos/quotations/form/:id',
        name: 'pos-quotation-form',
        component: () => import('@/views/pos/quotation/QuotationForm.vue'),
        meta: { title: 'Carada POS - Quotations' },
      },
      {
        path: '/pos/purchase_orders',
        name: 'pos-purchase-order',
        component: () => import('@/views/pos/purchase_order/PurchaseOrderList.vue'),
        meta: { title: 'Carada POS - Purchase Orders' },
      },
      {
        path: '/pos/purchase_orders/:id',
        name: 'pos-purchase-order-view',
        component: () => import('@/views/pos/purchase_order/PurchaseOrderView.vue'),
        meta: { title: 'Carada POS - Purchase Orders' },
      },
      {
        path: '/pos/purchase_orders/form/:id',
        name: 'pos-purchase-order-form',
        component: () => import('@/views/pos/purchase_order/PurchaseOrderForm.vue'),
        meta: { title: 'Carada POS - Purchase Orders' },
      },
      {
        path: '/pos/purchase_orders/goods_received/add',
        name: 'pos-goods-received-add',
        component: () => import('@/views/pos/purchase_order/GoodsReceivedForm.vue'),
        meta: { title: 'Carada POS - Goods Received' },
      },
      {
        path: '/pos/purchase_orders/notice_of_arrival/edit/:id',
        name: 'pos-notice-of-arrival-edit',
        component: () => import('@/views/pos/purchase_order/NoticeOfArrivalEdit.vue'),
        meta: { title: 'Carada POS - Notice of Arrival' },
      },
      {
        path: '/pos/requisitions',
        name: 'pos-requisition',
        component: () => import('@/views/pos/Requisition.vue'),
        meta: { title: 'Carada POS - Requisitions' },
      },
      {
        path: '/pos/tags',
        name: 'pos-tag-list',
        component: () => import('@/views/pos/TagList.vue'),
        meta: { title: 'Carada POS - Tags' },
      },
      {
        path: '/pos/customers',
        name: 'pos-customer',
        component: () => import('@/views/pos/Customer.vue'),
        meta: { title: 'Carada POS - Customers' },
      },
      {
        path: '/pos/delivery',
        name: 'pos-delivery',
        component: () => import('@/views/pos/DeliveryNote.vue'),
        meta: { title: 'Carada POS - Delivery' },
      },
      {
        path: '/pos/costings',
        name: 'pos-costing',
        component: () => import('@/views/pos/Costing.vue'),
        meta: { title: 'Carada POS - Costings' },
      },
      {
        path: '/pos/checkout',
        name: 'pos-checkout',
        component: () => import('@/views/pos/Checkout.vue'),
        meta: { title: 'Carada POS - Checkout' },
      },
      {
        path: '/pos/checkout-receipt',
        name: 'pos-checkout-receipt',
        component: () => import('@/views/pos/print/CheckoutReceipt.vue'),
        meta: { title: 'Carada POS - Checkout' },
      },
      {
        path: '/pos/checkout-receipt-2',
        name: 'pos-checkout-receipt-2',
        component: () => import('@/views/pos/print/CheckoutReceiptA4.vue'),
        meta: { title: 'Carada POS - Checkout' },
      },
      {
        path: '/pos/checkout-invoice',
        name: 'pos-checkout-invoice',
        component: () => import('@/views/pos/print/CheckoutInvoice.vue'),
        meta: { title: 'Carada POS - Checkout' },
      },
      {
        path: '/pos/checkout-invoice-return',
        name: 'pos-checkout-invoice-return',
        component: () => import('@/views/pos/print/CheckoutInvoiceReturn.vue'),
        meta: { title: 'Carada POS - Checkout' },
      },
      {
        path: '/pos/checkout-delivery-order',
        name: 'pos-checkout-delivery-order',
        component: () => import('@/views/pos/print/CheckoutDeliveryOrder.vue'),
        meta: { title: 'Carada POS - Checkout' },
      },
      {
        path: '/pos/password-change',
        name: 'password-change',
        component: () => import('@/views/PasswordChange.vue'),
        meta: { title: 'Carada - Password Change' },
      },
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    redirect: to => { return { name: 'admin-transaction' } },
    component: () => import('@/components/admin/body'),
    children: [
      {
        path: '/admin/dashboard',
        name: 'admin-dashboard',
        component: () => import('@/views/admin/Dashboard.vue'),
        meta: { title: 'Carada Admin - Dashboard' },
      },
      {
        path: '/admin/transactions',
        name: 'admin-transaction',
        component: () => import('@/views/admin/Transaction.vue'),
        meta: { title: 'Carada Admin - Transactions' },
      },
      {
        path: '/admin/inventory',
        name: 'admin-inventory',
        component: () => import('@/views/admin/Inventory.vue'),
        meta: { title: 'Carada Admin - Inventory' },
      },
      {
        path: '/admin/customers',
        name: 'admin-customer',
        component: () => import('@/views/admin/Customer.vue'),
        meta: { title: 'Carada Admin - Customers' },
      },
      {
        path: '/admin/suppliers',
        name: 'admin-supplier',
        component: () => import('@/views/admin/Supplier.vue'),
        meta: { title: 'Carada Admin - Suppliers' },
      },
      {
        path: '/admin/quotations',
        name: 'admin-quotation',
        component: () => import('@/views/admin/quotation/QuotationList.vue'),
        meta: { title: 'Carada Admin - Quotations' },
      },
      {
        path: '/admin/quotations/form/:id?',
        name: 'quotation-form',
        component: () => import('@/views/admin/quotation/QuotationForm.vue'),
        meta: { title: 'Carada Admin - Quotations' },
      },
      {
        path: '/admin/quotations/:id',
        name: 'quotation-view',
        component: () => import('@/views/admin/quotation/QuotationView.vue'),
        meta: { title: 'Carada Admin - Quotations' },
      },
      {
        path: '/admin/official_receipts',
        name: 'admin-official-receipt',
        component: () => import('@/views/admin/OfficialReceipt.vue'),
        meta: { title: 'Carada Admin - Official Receipts' },
      },
      {
        path: '/admin/credit_notes',
        name: 'admin-credit-note',
        component: () => import('@/views/admin/CreditNote.vue'),
        meta: { title: 'Carada Admin - Credit Notes' },
      },
      {
        path: '/admin/debtor_statement',
        name: 'admin-debtor-statement',
        component: () => import('@/views/admin/DebtorStatement.vue'),
        meta: { title: 'Carada Admin - Debtor Statement' },
      },
      {
        path: '/admin/master_logs',
        name: 'admin-master-log',
        component: () => import('@/views/admin/MasterLog.vue'),
        meta: { title: 'Carada Admin - Logs' },
      },
    ]
  },
  {
    path: '/second_screen',
    name: 'second-screen',
    component: () => import('@/views/pos/second_screen/Checkout.vue'),
    meta: { title: 'Carada POS - Second Screen' },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/Login.vue'),
  }]

const router = new Router({
  routes,
  base: '/',
  mode: 'history',
  linkActiveClass: "active",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const authHeaders = $cookies.get('userAuth')
  const authData = $cookies.get('userData')
  if (from.path.includes("/pos") || from.path.includes("/admin") && !authHeaders) return next()
  if (to.path == "/login") {
    if (authHeaders) {
      return next('/')
    } else {
      return next()
    }
  }
  if (!authHeaders) return next({ name: 'auth-login' })

  if (to.path.includes('/admin') && !$cookies.get('adminPage')) {
    return next({ name: 'pos', params: { verify_password: true } })
  }
  if (to.path.includes('/pos/purchase_orders/goods_received')) {
    if (authData['role'] != 'Admin' && authData['id'] != 20) {
      return next('/pos')
    }
  }
  if (to.path.includes('/pos/costings')) {
    if (authData['id'] == 13) {
      return next('/pos')
    }
  }
  if (to.path.includes('/pos/transactions') || to.path.includes('/pos/quotations') || to.path.includes('/pos/purchase_orders')) {
    if (authData['id'] == 15) {
      if (to.path.includes('/pos/purchase_orders')) return next('/pos')
    } else if (authData['role'] == 'Clerk' || authData['role'] == 'Stockist') {
      return next('/pos')
    }
  }
  if (to.path.includes('/admin/master_logs')) {
    if (authData['id'] !== 3 && authData['id'] !== 7) {
      return next('/admin')
    }
  }
  if (to.path.includes('/admin/official_receipts')) {
    if (authData['id'] !== 3 && authData['id'] !== 7 && authData['id'] !== 5) {
      return next('/admin')
    }
  }
  if (to.path.includes('/admin/credit_notes')) {
    if (authData['id'] !== 3 && authData['id'] !== 7 && authData['id'] !== 5 && authData['id'] !== 11 && authData['id'] !== 20) {
      return next('/admin')
    }
  }
  if (to.path.includes('/admin/debtor_statement')) {
    if (authData['id'] !== 3 && authData['id'] !== 7 && authData['id'] !== 5 && authData['id'] !== 11 && authData['id'] !== 20) {
      return next('/admin')
    }
  }
  return next()
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || 'Carada - Automotive Parts'
  })
})

export default router
